<template>
  <div class="menu-box" :class="isMaster ? '' : 'menu-box__dev'">
    <div class="the-menu-logo" v-if="is_collapse">
      <!-- <img class="logo" :src="logo" /> -->
    </div>
    <div class="the-menu-logo" v-else>
      <img
        v-show="isMaster"
        style="width: 54px; height: 24px"
        src="../assets/boe.png"
        alt=""
      />
      <span class="menu-envTitle" v-show="!isMaster">{{ envTitle }}</span>
    </div>
    <el-select
      size="small"
      class="select menu_box_select"
      v-if="isPurchase && !is_collapse"
      v-model="currentMenu"
      @change="handleMenuChange"
      filterable
      clearable
      ref="selection"
      placeholder="请选择"
      :class="isMaster ? '' : 'menu_box__dev'"
    >
      <el-option
        v-for="item of menuData"
        :key="item.secondResourcesId"
        :index="item.secondResourcesId"
        :value="item"
        :label="getMainMenuLabel(item)"
      ></el-option>
    </el-select>
    <el-menu
      class="the-menu"
      v-if="!noMenu"
      :collapse="is_collapse"
      :default-active="this.$route.fullPath"
      :active-text-color="themeMenu.active_text"
      :unique-opened="true"
      menu-trigger="click"
      :class="isMaster ? '' : 'the-menu__dev'"
      router
    >
      <el-submenu
        v-for="sub of menu"
        :key="sub.id"
        :index="sub.id"
        :class="isMaster ? '' : 'el-submenu__dev'"
      >
        <template slot="title">
          <i class="menu-icon" :class="sub.icon"></i>
          <span class="menu-sub-title">{{ getMenuLabel(sub) }}</span>
        </template>
        <el-menu-item
          v-for="item of sub.children"
          :key="item.id"
          :index="item.url"
          @click="goto(item)"
        >
          <span class="menu-item-title">{{ getMenuLabel(item) }}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="menuCollapseDiv" :class="is_collapse ? 'isCollapse' : ''">
      <i
        class="icon-navicon"
        :class="!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
        @click="setMenuCollapseStatus()"
      ></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"; // 引入状态共享

import { routerGo } from "@/util/utils.js"; // 引入跨应用路由跳转
import { queryUrlParams } from "@/util/util.js";
import { getMenu, getBtn, getSupplierMenu, eventTracking } from "@/api/menu"; // 获取菜单列表
// import { subApps } from "@/api/purchase_menu"; // 获取菜单列表
import { getStore, setStore } from "@/util/store";
import { ENV_TITLE } from "../util/themeSplitTitle.js";
import store from "../store";
import uasUpdate from "../core/uas-info.js";
export default {
  name: "theMenu",
  data() {
    return {
      currentMenu: null,
      default_lang: "zh_cn",
      // logo: require("../assets/logo.png"),
      userInfo: {},
      isPurchase: false,
      envTitle: ENV_TITLE,
      noMenu: false,
      theme_menu: {
        background: "#005EBA",
        text: "#fff",
        active_text: "#fff",
      }, // 菜单主
      menuData: [],
      itemList: [],
      currentENV: process.env.RUN_ENV,
      urltestData: {
        A0083:
          "https://dsstest.boe.com.cn/webroot/decision/v5/design/report/0821a808fe9f4c8fb268dd3e7af00508/view",
        A0082:
          "https://dsstest.boe.com.cn/webroot/decision/v5/design/report/a1aeaf2097c74c9f8195c295bf1582b6/view",
        A0081:
          "https://dsstest.boe.com.cn/webroot/decision/view/report?ref_c=a963207b-5c6f-4faf-861a-62ca96656022&viewlet=MSC%25E6%258A%25A5%25E8%25A1%25A8%252F%25E4%25BA%25A4%25E6%259C%259F%25E7%25A8%25BD%25E6%259F%25A5.cpt&ref_t=design",
      },
      urlprodData: {
        A0083:
          "https://dss.boe.com.cn/webroot/decision/v5/design/report/f41fae0785b8404e9c9f489627b28e1d/view",
        A0082:
          "https://dss.boe.com.cn/webroot/decision/v5/design/report/c55029f3736a450d8d466c2b7a8eea8b/view",
        A0081:
          "http://dss.boe.com.cn:8080/webroot/decision/view/report?viewlet=Msc%252F%25E4%25BA%25A4%25E6%259C%259F%25E7%25A8%25BD%25E6%259F%25A5.cpt&ref_t=design&ref_c=71518f1c-8e9b-43d6-b076-289a8f487d52",
      },
    };
  },
  mounted() {
    this.default_lang = store.state.appstore.language;
    console.log(this.default_lang, "language");
    this.userInfo = getStore({ name: "userInfo" }) || {};
    this.isPurchase = this.userInfo.is_purchaser === "1";
    if (this.isPurchase) {
      this.showMenu();
    } else {
      const url = window.location;
      console.log(this.tagList, "this.tagList");
      // if (!this.tagList.length) {
      //   if (url.hash.includes("supbascInfo")) {
      //     let routeItem = {
      //       title: "企业基本信息",
      //       id: "1-1-1",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "企业基本信息",
      //     };
      //     this.goto(routeItem);
      //   }
      //   if (url.hash.includes("salecomparison")) {
      //     let routeItem = {
      //       title: "报价",
      //       id: "1-2-1",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "报价",
      //     };
      //     this.goto(routeItem);
      //   }
      //   if (url.hash.includes("salebidding")) {
      //     let routeItem = {
      //       title: "投标",
      //       id: "1-2-2",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "投标",
      //     };
      //     this.goto(routeItem);
      //   }
      //   if (url.hash.includes("DeliveryPlan")) {
      //     let routeItem = {
      //       title: "交货计划确认-器件",
      //       id: "1-4-1",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "交货计划确认-器件",
      //     };
      //     this.goto(routeItem);
      //   }
      //   if (url.hash.includes("salefinancing")) {
      //     let routeItem = {
      //       title: "对账单管理",
      //       id: "1-5-1",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "对账单管理",
      //     };
      //     this.goto(routeItem);
      //   }

      //   if (url.hash.includes("supplierInfo")) {
      //     let routeItem = {
      //       title: "信息变更",
      //       id: "1-1-2",
      //       url: `${url.pathname}${url.hash}`,
      //       i18nkey: "信息变更",
      //     };
      //     this.goto(routeItem);
      //   }
      // }
      this.showSupMenu(url);
    }
    uasUpdate(this.userInfo);
    if (window.location.href.includes("ticket=")) {
      const URL = window.location.href.split("?ticket=")[0];
      window.location.href = URL;
    }
  },
  watch: {
    "$store.state.appstore.language": {
      handler(newVal) {
        if (newVal) {
           this.default_lang = newVal;
        }
      },
      deep: true,
    },
  },
  computed: {
    //左侧菜单栏是否收缩
    isCollapse() {
      return this.$store.getters.is_collapse;
    },
    // 左侧菜单主题
    themeMenu() {
      return this.theme_menu;
    },
    // 当前环境
    isMaster() {
      return location.host.includes("prd") || location.host === "bsrm.boe.com";
    },
    // 导入vuex菜单数据，菜单折叠状态,标签列表
    ...mapGetters(["menu", "is_collapse", "tagList", "default_open_menu"]),
  },
  methods: {
    getMainMenuLabel(item) {
      switch (this.default_lang) {
        case "zh_cn":
          return item.secondResourcesName;
        case "en":
          return item.secondResourcesNameEn ? item.secondResourcesNameEn : item.secondResourcesName;
        default:
          return item.secondResourcesName;
      }
    },
    getMenuLabel(item) {
      switch (this.default_lang) {
        case "zh_cn":
          return item.title;
        case "en":
          // console.log(item,'item')
          return item.ResourcesNameEn ? item.ResourcesNameEn : item.title;
        default:
          return item.title;
      }
    },
    // 设置左侧菜单折叠状态
    setMenuCollapseStatus() {
      this.$store.dispatch("menu/setCollapseStatus", !this.isCollapse);
    },
    handleMenuChange(item) {
      console.log(item);
      if (item !== "") {
        let routeItem = {
          title: item.secondResourcesName,
          icon: item.icon,
          id: item.secondResourcesCode,
          url: item.url,
          value: item.url,
          i18nKey: item.title,
          label: item.secondResourcesName,
          ResourcesNameEn: item.secondResourcesNameEn,
          ResourcesNameEs: item.secondResourcesNameEs,
          ResourcesNameVn: item.secondResourcesNameVn,
        };
        this.goto(routeItem);
        this.$set(this, "currentMenu", null);
      }
    },
    async showSupMenu(url) {
      const userInfo = this.userInfo;
      const isPurchase = this.isPurchase;
      const res = await getSupplierMenu();
      if (res.code === 200) {
        setStore({ name: "menu", content: res.data, type: "session" });
        if (userInfo && userInfo.access_token && !isPurchase) {
          this.menuData = res.data;

          this.itemList = this.sortList(res.data);
          const urlItem = this.menuData.find((ele) => {
            return ele.url.includes(url.hash);
          });
          console.log(urlItem, "item1");
          if (!this.tagList.length) {
            if (urlItem) {
              let routeItem = {
                title: urlItem.secondResourcesName,
                id: "1-1-1",
                url: `${url.pathname}${url.hash}`,
                ResourcesNameEn: urlItem.secondResourcesNameEn,
                ResourcesNameEs: urlItem.secondResourcesNameEs,
                ResourcesNameVn: urlItem.secondResourcesNameVn,
                i18nkey: urlItem.secondResourcesName,
              };
              this.goto(routeItem);
            }
          }
        }
      }
      // await this.mapBtnSetData(this.itemList);
      await this.handlerMenuData(this.menuData);
    },
    // 跨应用路由跳转
    async showMenu() {
      const userInfo = this.userInfo;
      const isPurchase = this.isPurchase;
      const res = await getMenu();
      if (res.code === 200) {
        setStore({ name: "menu", content: res.data, type: "session" });
        if (
          userInfo &&
          userInfo.access_token &&
          isPurchase &&
          userInfo.user_code !== "100000"
        ) {
          this.menuData = res.data;
          this.itemList = this.sortList(res.data);
        }
      }
      await this.mapBtnSetData(this.itemList);
      await this.handlerMenuData(this.menuData);
    },
    sortList(list) {
      if (!list.length) {
        return [];
      }
      const array = [...list];
      const setAry = new Set(array.map((item) => item.firstResourcesCode));
      const obj = {};
      setAry.forEach((item) => {
        obj[item] = list
          .filter((child) => item === child.firstResourcesCode)
          .map((conten) => conten.secondResourcesId)
          .join();
      });
      return obj;
    },
    async mapBtnSetData(data) {
      let _this = this;
      const ids = Object.values(data);
      const allList = [];
      const ID = ids.toString();
      allList.push(getBtn(ID));
      await _this.$http.all(allList).then(
        _this.$http.spread(function(...ary) {
          let resData = [];
          ary.forEach((item) => {
            resData = resData.concat(item.data);
          });
          for (let i = 0; i < _this.menuData.length; i++) {
            for (let index = 0; index < resData.length; index++) {
              if (
                _this.menuData[i].secondResourcesId ===
                resData[index].secondResourcesId
              ) {
                _this.menuData[i].btnList = resData[index].btnList;
                break;
              }
            }
          }
        })
      );
    },
    handlerMenuData(data) {
      const menuObj = {};
      const appObj = {};
      const btnObj = {};
      data.forEach((item) => {
        if (!item.firstResourcesCode) {
          return item;
        }
        if (menuObj[item.firstResourcesCode]) {
          const obj = {
            id: item.secondResourcesCode,
            ResourcesNameEn: item.secondResourcesNameEn,
            ResourcesNameEs: item.secondResourcesNameEs,
            ResourcesNameVn: item.secondResourcesNameVn,
            title: item.secondResourcesName,
            btns: item.btnList,
            icon: item.icon,
            url: item.url,
          };
          if (!appObj[item.secondResourcesName]) {
            menuObj[item.firstResourcesCode].children.push(obj);
            appObj[item.secondResourcesName] = true;
          }
        } else {
          menuObj[item.firstResourcesCode] = {
            id: item.firstResourcesCode,
            title: item.firstResourcesName,
            ResourcesNameEn: item.firstResourcesNameEn,
            ResourcesNameEs: item.firstResourcesNameEs,
            ResourcesNameVn: item.firstResourcesNameVn,
            icon: item.icon,
            children: [
              {
                id: item.secondResourcesCode,
                title: item.secondResourcesName,
                ResourcesNameEn: item.secondResourcesNameEn,
                ResourcesNameEs: item.secondResourcesNameEs,
                ResourcesNameVn: item.secondResourcesNameVn,
                btns: item.btnList,
                url: item.url,
              },
            ],
          };
          appObj[item.secondResourcesCode] = true;
        }
        btnObj[item.secondResourcesCode] = item.btnList;
      });
      const _menu = Object.values(menuObj);
      store.dispatch("menu/setMenu", _menu);
      console.log("_menu", _menu);
      setStore({ name: "newMenu", content: menuObj, type: "session" });
      setStore({ name: "btnObj", content: btnObj, type: "session" });
      //区分跳转新部品
      if (this.isPurchase) {
        this.openTagHandler(menuObj);
      }
    },
    openTagHandler(menuObj) {
      // console.log(menuObj);
      const homePageObj = {
        title: "首页",
        url: "/vendor/#/wel",
        i18nkey: "i18n_index",
        value: "/vendor/#/wel",
        label: "首页",
      };
      // 新增的新部品portal跳转
      if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("scmpls")
      ) {
        let tempUrl = window.location.href;
        const urlParams = { ...queryUrlParams(tempUrl) };
        let splitStr = "/scmpls";
        let tempObj = menuObj["G010"].children.find((md) => {
          if (urlParams.isTodo == "0") return md.title === "项目工作台";
          else return md.title === "待办任务";
        });
        let tempItem = { ...tempObj };
        // tempItem.url = splitStr + tempUrl.split(splitStr)[1];
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          ResourcesNameEn: tempObj.secondResourcesNameEn,
          ResourcesNameEs: tempObj.secondResourcesNameEs,
          ResourcesNameVn: tempObj.secondResourcesNameVn,
          value: splitStr + tempUrl.split(splitStr)[1],
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
      }
      // 设备数字化待办
      else if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("equipmentIntegration")
      ) {
        let splitStr = "/equipmentIntegration";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G018"].children.find((md) => {
          if (window.location.href.includes("supplierList/detail")) {
            return md.id === "equipmentSupplierList";
          } else if (window.location.href.includes("deviceList")) {
            return md.id === "equipmentTechnicalEvaluation";
          } else if (window.location.href.includes("budgetExecution")) {
            return md.id === "budgetExecution";
          }
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
      }
      // 设备数字化-设备商务交流待办
      else if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("isEquipment")
      ) {
        let splitStr = "/rfx";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G018"].children.find((md) => {
          return md.id === "equipmentBidding";
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
      }
      // IPN MPN 主数据 关系管理
     // /system/#/IpnMpnRelation/handoverDetail?id=3&sendSign=Portal
      else if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("ipnMpn")
      ) {
        let splitStr = "/system";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G10_11"].children.find((md) => {
          return md.id === "IpnMpnRelation";
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
        // 新增的供应商管理portal跳转
      }
      // IPN MPN 主数据 确认管理
      // /system/# / IpnMpnConfirmRelation / edit ? id = 52 & dutyType=1 & sendSign=Portal & portalToken=
      else if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("IpnMpnConfirmRelation")
      ) {
        let splitStr = "/system";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G010"].children.find((md) => {
          return md.id === "IpnMpnConfirmRelation";
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
        // 新增的供应商管理portal跳转
      }
      // IPN MPN 主数据 定供管理
      // /system/# / customizedSupplyManage/edit/243&sendSign=Portal&portalToken=
      else if (
        window.location.href.includes("sendSign") &&
        window.location.href.includes("customizedSupplyManage")
      ) {
        let splitStr = "/system";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G010"].children.find((md) => {
          return md.id === "customizedSupplyManage";
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
        // 新增的供应商管理portal跳转
      } else if (window.location.href.includes("onlyView")) {
        // potal单点供应商详情
        this.noMenu = true; // 不展示菜单
        // 新增的供应商管理portal跳转
      } else if (window.location.href.includes("basic/detail")) {
        const splitStr = "/vendor";
        const preStr = window.location.href.split(splitStr)[1];
        let todoObj = {
          title: "供应商管理",
          url: "/vendor/#/basiclist",
          i18nkey: "i18n_Supplier_management",
          value: splitStr + preStr,
          label: "供应商管理",
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
      } else if (this.ifFromSupplierProfile()) {
        const todoObj = this.getFromSupplierProfileTodoObj();
        this.goto(todoObj);
      } else if (window.location.href.includes("isBidding")||window.location.href.includes("zxzBidding")) {
        let splitStr = "/rfx";
        const preStr = window.location.href.split(splitStr)[1];
        let tempObj = menuObj["G004"].children.find((md) => {
          return md.id === "mybidding";
        });
        let tempItem = { ...tempObj };
        let todoObj = {
          ...tempItem,
          label: tempObj.title,
          value: splitStr + preStr,
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.$store.commit("ADD_TAG", todoObj);
        this.$root.$emit("openTag", todoObj);
        this.noMenu = false;
      } else {
        this.noMenu = false;
        if (!this.tagList.length) {
          this.goto(homePageObj);
        }
      }
    },
    // 判断是否是通过供应商档案详情页面履历变更单据跳转
    ifFromSupplierProfile() {
      const todoArr = [
        "/admittance/detail",
        "/supplierextend/detail",
        "/informationchange/detail",
        "/specialapprover/detail",
        "/freeze/detail",
        "/examine/detail",
        "/supplierBatchMaintenance/exit",
        "/approvalResults",
      ];

      let bool = false;
      todoArr.forEach((item) => {
        if (window.location.href.includes(item)) {
          bool = true;
        }
      });
      return bool;
    },
    // 获取从供应商档案详情页面，履历变更单据的页面标题
    getFromSupplierProfileTodoObj() {
      const splitStr = "/vendor";
      const preStr = window.location.href.split(splitStr)[1];
      const path = splitStr + preStr;
      if (window.location.href.includes("/admittance/detail")) {
        return { title: "代理商准入", url: path };
      } else if (window.location.href.includes("/supplierextend/detail")) {
        return { title: "供应商扩展", url: path };
      } else if (window.location.href.includes("/informationchange/detail")) {
        return { title: "供应商信息变更", url: path };
      } else if (window.location.href.includes("/specialapprover/detail")) {
        return { title: "供应商特批", url: path };
      } else if (window.location.href.includes("/freeze/detail")) {
        return { title: "供应商退出/重新导入", url: path };
      } else if (window.location.href.includes("/examine/detail")) {
        return { title: "供应商审核", url: path };
      } else if (
        window.location.href.includes("/supplierBatchMaintenance/exit")
      ) {
        return { title: "供应商批量维护", url: path };
      } else if (window.location.href.includes("/approvalResults")) {
        return { title: "代理商管理", url: path };
      } else {
        return null;
      }
    },

    goto(item) {
      console.log(item, "item111");
      let toUrl = "";
      let hostStr = window.location.host.includes("prd");

      if (item.url === "SupplierRiskControl") {
        if (this.userInfo.user_center_token) {
          window.open(
            `https://smrc.boe.com.cn/#/supplier-data/index?supplier_token=${this.userInfo.user_center_token}`,
            "_blank"
          );
          routerGo("/vendor/#/wel", "首页");
        } else {
          return this.$message.error("无法访问，请联系管理员");
        }
      } else if (this.urltestData[item.id]) {
        if (hostStr) {
          toUrl = this.urlprodData[item.id];
        } else {
          toUrl = this.urltestData[item.id];
        }
        window.open(toUrl);
      } else {
        if (item.url === "/rfx/#/factorymanage?mode=bidding") {
          this.handJob(1);
        } else if (item.url === "/rfx/#/factorymanage?mode=enquiry") {
          this.handJob(2);
        }
        routerGo(item.url, item.title);
        const tagObj = {
          label: item.title,
          value: item.url,
          ResourcesNameEn: item.secondResourcesNameEn,
          ResourcesNameEs: item.secondResourcesNameEs,
          ResourcesNameVn: item.secondResourcesNameVn,
          ...item,
        };
        this.$root.$emit("openTag", tagObj);
      }
    },
    findTag(value) {
      let tag, key;
      this.tagList.forEach((item, index) => {
        if (item.label === value || this.$t(item.i18nKey) === value) {
          tag = item || this.$t(item.i18nKey);
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    handJob(num) {
      // const userInfo = getUserInfo();
      const data = {
        systemCode: "SYS00007",
        systemName: "供应商关系管理系统",
        targetUrl:
          num === 1
            ? "/rfx/#/factorymanage/bidding"
            : "/rfx/#/factorymanage/enquiry",
        pageUrl:
          num === 1
            ? "/rfx/#/factorymanage/bidding"
            : "/rfx/#/factorymanage/enquiry",
        userId: this.userInfo.user_code,
      };
      eventTracking(data);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select {
  width: 200px;
  padding-left: 10px;
}
</style>

<style lang="scss">
.menu-box {
  background-color: #005eba !important;
  position: relative;
}

.the-menu:not(.el-menu--collapse) {
  width: 212px;
  min-height: 400px;
  overflow-x: hidden;
  overflow: auto;
}
.el-menu--collapse {
  height: calc(100% - 100px) !important;
  width: 50px;
  text-align: center;
  .el-submenu__title {
    padding-left: 17px !important;
  }
}
.el-submenu__title {
  height: 40px !important;
  line-height: 35px !important;
  span {
    font-size: 14px;
    color: #fff;
    line-height: 22px;
    font-weight: 600;
  }
}
.el-menu-item {
  height: 40px !important;
  line-height: 35px !important;

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
    line-height: 22px;
    font-weight: 400;
  }
}
.the-menu-logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  // background-color: #005889;
  .menu-envTitle {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
  }
}

.logo {
  padding-left: 40px;
}

.el-menu {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

.el-submenu:hover .el-submenu__title,
.el-submenu.is-opened {
  background: rgba(4, 122, 238, 0.6);
  text-align: left;
}

.el-submenu.is-active {
  text-align: left;
  width: 100%;
  clear: both;
}

.el-submenu {
  text-align: left;
}

.the-menu {
  height: calc(100% - 140px);
  border-color: #005eba;
  background-color: #005eba !important;

  &.el-menu {
    background-color: #005eba !important;
  }

  .el-menu-item {
    color: #fff;
    text-align: left;
    background-color: #005eba;
  }

  .el-menu-item.is-active {
    border-left: 2px solid #fff;
    background: rgba(4, 122, 238, 0.6);
  }

  .el-menu-item:hover,
  .el-menu-item:hover .menu-sub-title {
    background: rgba(4, 122, 238, 0.6);
  }

  .menu-icon {
    color: #fff;
    font-size: 16px;
  }

  .menu-sub-title {
    margin-left: 6px;
    font-weight: 600;
    color: #fff;
  }
}
.el-submenu__title i {
  color: #5d98d3;
}
.menuCollapseDiv {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 40px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  border-top: 1px solid;
  border-color: rgba(255, 255, 255, 0.2);
}
.isCollapse.menuCollapseDiv {
  padding: 0 20px 0 15px;
}
.icon-navicon {
  color: #ffffff;
  cursor: pointer;
}

.el-menu--vertical {
  .el-menu--popup {
    background-color: #ffffff !important;
  }
  .el-menu {
    background: #ffffff;
  }
  .el-menu-item {
    background: #ffffff;
    //color: #000000;
    &:hover {
      background: #f0f8fe !important;

      .menu-item-title {
        color: #005eba;
      }
    }
    .menu-item-title {
      color: #000000;
    }
  }
}
@import "../styles/themeSplit.scss";
.menu_box_select {
  margin-top: 6px;
  .el-input__inner {
    background-color: transparent;
    color: #fff;
  }
  .el-input.is-focus .el-input__inner {
    border-color: #fff !important;
  }
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border-color: #fff !important;
}
/deep/.el-select .el-input__inner:focus {
  border: 1px solid #fff !important;
}
// /deep/.el-select .el-input.is-focus .el-input__inner{
//    border-color: #fff !important;
// }
/deep/ .el-select {
  /deep/.el-input.is-focus {
    /deep/.el-input__inner {
      border-color: #fff !important;
    }
  }
}
</style>
